import { render, staticRenderFns } from "./privacyTermModal.vue?vue&type=template&id=5d5d2cfa&scoped=true"
import script from "./privacyTermModal.vue?vue&type=script&lang=js"
export * from "./privacyTermModal.vue?vue&type=script&lang=js"
import style0 from "./privacyTermModal.vue?vue&type=style&index=0&id=5d5d2cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d2cfa",
  null
  
)

export default component.exports